namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_fontsize, {
		
		Font_size: {
			width: '4rem',
		},
		Inc_dec: {
			flex: {
				direction: 'column',
			},
		},
		Inc: {
			height: '20px',
			padding: {
				top: 0,
				bottom: 0,
				left: $mol_gap.space,
				right: $mol_gap.block,
			},
			minHeight: 0,
		},
		Dec: {
			height: '20px',
			padding: {
				top: 0,
				bottom: 0,
				left: $mol_gap.space,
				right: $mol_gap.block,
			},
			minHeight: 0,
		},

		
	} )
	
}
